const sites = ["youtube", "kaggle", "medium", "github", "udemy", "linkedin", "twitter"]

const linkToKey=(url)=>{
    let found = sites.filter(site=>{
        return url.match(site) !== null
            
    })
    if (found.length==0){
        return "webapp"
    }
    return found[0]
}
const Lib = {
    linkToKey
}
export default Lib